import React from 'react';

const TableHeader: React.FC = props => {
  return <thead className="TableHeader">{props.children}</thead>;
};

export default TableHeader;
